<script>
	import Loading from '../loading/Loading.svelte';
    import { onMount } from "svelte";
    const clsPredix = "sui-indexbar";
    let groups = [];
    let active = "A";
    const iH = window.innerHeight;
    let aDl;
    let inow = -1;
    let show = false;
    onMount(() => {
        show = true;
        fetch("/api/car.json", {})
            .then((response) => response.json())
            .then((res) => {
                groups = res;
                active = groups[0].title;
                show = false;
                setTimeout(() => {
                    aDl = document.querySelectorAll("dl");
                });
            });
        //
        window.addEventListener("scroll", scrollFn);
        return () => {
            window.removeEventListener("scroll", scrollFn);
        };
    });

    function scrollFn() {
        if (!aDl) {
            aDl = document.querySelectorAll("dl");
        }
        aDl.forEach((el) => {
            ditect(el);
        });
    }

    function ditect(el) {
        const { top, bottom } = el.getBoundingClientRect();
        if (bottom >= 0 && top <= 0) {
            active = el.id;
        }
    }
    function pick(data) {
        //todo
    }
</script>

<div class={clsPredix}>
    {#each groups as group}
        <dl id={group.title} class={`${clsPredix}-group`}>
            <dt>首字母{group.title}</dt>
            {#each group.items as item, index}
                <dd
                    on:click={() => pick(item)}
                    on:touchstart={() => (inow = index)}
                    on:touchend={() => (inow = -1)}
                    class:active={index === inow}
                >
                    {item.name}
                </dd>
            {/each}
        </dl>
    {/each}

    <div class={`${clsPredix}-aside`}>
        {#each groups as group}
            <a
                href={`#${group.title}`}
                on:click|stopPropagation={() => (active = group.title)}
                class:active={active === group.title}
            >
                <span>{group.title}</span>
            </a>
        {/each}
    </div>
</div>

<Loading show={show}/>

<style lang="less">
    @import "./indexBar.less";
</style>
